import {useQuery} from "@tanstack/react-query";
import axios from "axios";

/*const fetchUsers2 = async () => {
    /!*const res = await fetch("http://localhost:8000/ProductsList");
    if (!res.ok) throw new Error("خطا در دریافت داده");
    return res.json();*!/

};*/






function About() {


    const fetchUsers= async ()=>{

        try {
            // const response = await axios.get('http://localhost:8000/ProductsList');
            const response = await axios.get('https://fixstyle.ir/api/public-products');
            // console.log(response.data);
            // setProducts(response.data.data);
            return response.data
        } catch (error) {
            console.error(error);
            return error
        }

    }







    const {data , isLoading, error, isPending,refetch} = useQuery({
        queryKey: ["users"],
        queryFn: fetchUsers,
    });






    // console.log("✅ Data:", data);
    // let data2 = data
    // console.log(data?.data)
    if (isPending) return <span>Loading...</span>
    if (isLoading) return <span>Loading222222222...</span>
    if (error) return <span>Oops! {error.message}</span>
    return (
        <div className='container'>
            <p>About</p>
            <button type="button" className='btn btn-warning' onClick={refetch}>reFetch</button>
            <div className='row'>
                {data?.map((d) => {
                    return (<div className="col-3" key={d.id}>
                        <img className="card-img-top" height="200px" alt="498"  src={'https://fixstyle.ir/img/product/thumbnails/'+d.images.url} />
                    <p>{d.name}</p>
                </div>)
                })}
            </div>
        </div>
    )
}

export default About


